import { Field } from 'ngx-angular-query-builder';
import { FieldMetadata, FieldMetadataCollection } from '@common/filter/field-metadata';
import { FilterListItem } from '@common/filter/models/filter-list-item.model';
import { FieldMetaDataAvailableCallback } from '@common/filter/field-metadata';

export interface FilterFieldProvider {
  getFilterFields(): Array<Field>;
  getFieldNameFromLabel(label: string): string;
  getFilterField(fieldName: string): Field;
}

/**
 * Helper class that can be used to assist in building FieldMetadataCollections
 */
export class FieldMetadataCollectionBuilder {

  constructor(
    private readonly fieldMetaDataCollection: FieldMetadataCollection
  ) { }

  add(label: string, fieldName: string, type: string, operators: string[], options: FilterListItem[], availabilityCallback?: FieldMetaDataAvailableCallback) {

    const field: Field = {
      name: label,
      type: type,
      operators: operators,
      options: options,
    };

    this.fieldMetaDataCollection.set(field.name, new FieldMetadata(fieldName, field, availabilityCallback));

  }

}

